import { Component, OnInit, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { PreviewAvatarComponent } from '../preview-avatar/preview-avatar.component';

@Component({
  selector: 'app-choose-avatar',
  templateUrl: './choose-avatar.component.html',
  styleUrls: ['./choose-avatar.component.scss']
})
export class ChooseAvatarComponent implements OnInit {

  AvatarEndpoint = 'https://cdn2.tda.website/beehive/20200826/';
  Avatars: string[] = ['adult-2221018.svg', 'adventurer-2220955.svg', 'air-hostess-2220960.svg', 'architect-2221005.svg', 'artist-2221019.svg', 'astronaut-2220995.svg', 'athlete-2220996.svg', 'auditor-2220964.svg', 'baker-2221007.svg', 'ballerina-2220933.svg', 'blogger-2220943.svg', 'boy-2220946.svg', 'butcher-2220974.svg', 'carpenter-2220949.svg', 'chemist-2220984.svg', 'clerk-2220935.svg', 'cobbler-2220938.svg', 'con-man-2220941.svg', 'cook-2221023.svg', 'delivery-man-2220950.svg', 'designer-2220985.svg', 'dj-2220961.svg', 'driver-2220948.svg', 'engineer-2221022.svg', 'executive-2220989.svg', 'farmer-2221026.svg', 'female-cop-2220990.svg', 'firefighter-2220968.svg', 'florist-2220951.svg', 'gardener-2221000.svg', 'geographer-2220983.svg', 'girl-2220932.svg', 'girl-2220940.svg', 'gopnik-2220931.svg', 'hipster-2221008.svg', 'historian-2220982.svg', 'housemaid-2221016.svg', 'housewife-2221012.svg', 'hunter-2220928.svg', 'hunter-2220956.svg', 'interpreter-2220988.svg', 'judge-2220980.svg', 'labor-2221020.svg', 'lady-2220991.svg', 'lady-doctor-2221025.svg', 'lawyer-2220947.svg', 'librarian-2220969.svg', 'lifeguard-2220979.svg', 'magician-2220939.svg', 'male-cop-2220965.svg', 'manager-2221017.svg', 'mechanic-2220930.svg', 'model-2221011.svg', 'musician-2221004.svg', 'newscaster-2220966.svg', 'nurse-2221001.svg', 'oceanographer-2220977.svg', 'photographer-2220986.svg', 'pilot-2221013.svg', 'pizza-boy-2220937.svg', 'plumber-2220978.svg', 'police-officer-2221024.svg', 'politician-2220971.svg', 'postman-2220959.svg', 'principal-2220970.svg', 'professor-2221006.svg', 'programmer-2220967.svg', 'radiographer-2220962.svg', 'referee-2220993.svg', 'reporter-2220945.svg', 'retro-woman-2220957.svg', 'robber-2221002.svg', 'sailor-2220975.svg', 'salesman-2220952.svg', 'scholar-2220994.svg', 'school-boy-2220944.svg', 'scientist-2220972.svg', 'scientist-2220976.svg', 'soldier-2221015.svg', 'sportsman-2220997.svg', 'spy-2220936.svg', 'student-2221010.svg', 'sweeper-2220981.svg', 'teacher-2221027.svg', 'teenager-2220963.svg', 'tourist-2220987.svg', 'vet-2220973.svg', 'vlogger-2220942.svg', 'waiter-2220999.svg', 'watchman-2221014.svg', 'welder-2220953.svg', 'woman-2221021.svg', 'writer-2221003.svg', 'accountant-2220992.svg', 'actor-2221009.svg', 'actress-2220958.svg'];

  constructor(
    @Inject(MAT_DIALOG_DATA) public Avatar: string,
    private dialog: MatDialog,
    private thisDialog: MatDialogRef<ChooseAvatarComponent>,
  ) { }

  ngOnInit(): void {
    this.Avatar = this.Avatar || 'adult-2221018.svg';
  }

  random(): void {
    const Avatar = this.Avatars[this.getRandomArbitrary(0, this.Avatars.length - 1)];
    const dialogRef = this.dialog.open(PreviewAvatarComponent, {
      data: Avatar,
      width: '500px',
    });
    dialogRef.afterClosed().subscribe(val => {
      if (val === true) {
        this.Avatar = Avatar;
        this.thisDialog.close(this.AvatarEndpoint + this.Avatar);
      } else if (val === 'random') {
        this.random();
      }
    });
  }

  getRandomArbitrary(min: number, max: number): number {
    return Math.round(Math.random() * (max - min) + min);
  }

}
